import { ArrowLeft, Mail, Globe } from "@/components/icons";
import { useNavigate } from "react-router-dom";

export default function InfoPage() {
  const navigate = useNavigate();
  return (
    <div className="space-y-5 fade-up max-w-2xl" data-testid="info-page">
      <button
        onClick={() => navigate(-1)}
        className="inline-flex items-center gap-2 text-[#1B405B] font-semibold text-sm hover:underline"
      >
        <ArrowLeft className="w-4 h-4" /> Volver
      </button>

      <div>
        <h1 className="text-3xl font-extrabold text-[#163144] tracking-tight">
          Acerca de ConsuDoctor
        </h1>
        <p className="text-sm text-[#1B405B]/70">
          Información del sistema y soporte.
        </p>
      </div>

      <div className="glass rounded-[28px] p-6 space-y-5">
        <div className="flex items-center gap-4">
          <img
            src="/brand/consudoctor-icon.png"
            alt="ConsuDoctor"
            className="w-14 h-14 rounded-2xl object-contain bg-white/70 border border-white/90 shadow-md p-1"
          />
          <div>
            <div className="font-extrabold text-lg text-[#163144]">ConsuDoctor</div>
            <div className="text-sm text-[#1B405B]/70">Versión 1.0 · 2026</div>
          </div>
        </div>

        <div className="border-t border-white/40 pt-5 space-y-3 text-sm text-[#1B405B]">
          <p>
            Plataforma de gestión clínica para doctores, secretarias, farmacias y administradores.
            Permite gestionar pacientes, agenda, recetas, finanzas y comisiones desde un solo lugar.
          </p>
          <p>
            Diseñado y construido a medida para clínicas y consultorios independientes que buscan
            simplificar sus operaciones día a día.
          </p>
        </div>

        <div className="border-t border-white/40 pt-5 space-y-2 text-sm">
          <div className="flex items-center gap-2 text-[#163144]">
            <Mail className="w-4 h-4 text-[#1B405B]/70" />
            <span className="font-semibold">soporte@emehealth.app</span>
          </div>
          <div className="flex items-center gap-2 text-[#163144]">
            <Globe className="w-4 h-4 text-[#1B405B]/70" />
            <span className="font-semibold">emehealth.app</span>
          </div>
        </div>
      </div>
    </div>
  );
}
